import { render, staticRenderFns } from "./DelayDataDetail.vue?vue&type=template&id=713d06d4&"
import script from "./DelayDataDetail.vue?vue&type=script&lang=js&"
export * from "./DelayDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports